import React from 'react';
import { titleForTab } from '../navFiles';
import TypewriterHeading from './TypewriterHeading';

const TabSectionHeader = ({ tabIndex }) => (
  <TypewriterHeading text={titleForTab(tabIndex)} tabIndex={tabIndex} />
);

export default TabSectionHeader;
